import { ROLES } from "../auth/roles";
import DashboardPadlockId from "../layouts/admin/DashboardPadlockIdAdmin";
import DashboardOperator from "../layouts/operator/DashboardOperator";
import Settings from "../layouts/Settings";

export const commonRoutes = [

  // no menú (compartida)
  { path: "/dashboardlock/:id", element: <DashboardPadlockId/>, roles:[ROLES.OPERATOR, ROLES.SUPERVISOR, ROLES.ADMIN] },

  { path: "/operator", element: <DashboardOperator/>, roles:[ROLES.OPERATOR] },
  { path: "/configuracion", element: <Settings/>, roles:[ROLES.OPERATOR, ROLES.SUPERVISOR, ROLES.ADMIN] },
];
